import Alert, { type AlertProps } from 'shared/Alert'

import { useAlerts, useRemoveAlert } from './context/hooks'

import Snackbar from '@mui/material/Snackbar'
import Stack from '@mui/material/Stack'

export const AlertManager: React.FC = () => {
  const alerts = useAlerts()

  const isAlerts = alerts.length > 0

  const removeAlert = useRemoveAlert()

  return (
    <Snackbar open={isAlerts} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ mt: 10.5 }}>
      <div>
        <Stack sx={{ width: '100%' }} spacing={1}>
          {alerts.map((alert: AlertProps) => {
            return <Alert key={alert.id} alert={alert} onAlertClose={removeAlert} />
          })}
        </Stack>
      </div>
    </Snackbar>
  )
}
